import { Add, Cancel, Modal } from "components/UI";
import ContactForm from "./ContactForm";
import { useState } from "react";
import dayjs from "dayjs";
import { useCreateContact } from "queries/contact";
import { useTranslation } from "react-i18next";
import { useAntdMessage } from "hooks/useAntdMessage";
import { Form } from "antd";

const AddFinanceContact = ({
  show,
  hideHandler,
  callback,
  zIndex,
  meetingMode = false,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { message } = useAntdMessage();
  const createNewContact = useCreateContact();
  const [loadingMutation, setLoadingMutation] = useState(false);

  const submitHandler = () => {
    form
      .validateFields()
      .then((values) => {
        let newValues = {
          ...values,
          ...(values.birthday
            ? { birthday: dayjs(values.birthday).format("YYYY-MM-DD") }
            : {}),
          type_id: Array.isArray(values.type_id)
            ? values.type_id.join(",")
            : values.type_id || "",
        };
        setLoadingMutation(true);
        createNewContact.mutate(newValues, {
          onSuccess: async (response) => {
            if (response.data.success) {
              message.success(t("contact_created"));
              hideHandler();
            }
            if (typeof callback === "function") {
              callback(response);
            }
            setLoadingMutation(false);
          },
          onError: (error) => {
            setLoadingMutation(false);
            if (!error.response.data.success) {
              message.error(t("contact_created_failed"));
            }
          },
        });
      })
      .catch((info) => {
        setLoadingMutation(false);
        if (info.errorFields && info.errorFields[0]) {
          form.scrollToField(info.errorFields[0].name);
        }
      });
  };

  return (
    <Modal
      wrapClassName="contact-modal"
      title={t("add_contact")}
      open={show}
      onCancel={hideHandler}
      maskClosable={false}
      destroyOnHidden
      style={{ top: 50 }}
      {...(zIndex != null && { zIndex })}
      footer={[
        <Cancel key={`_${0}`} onClick={hideHandler} />,
        <Add key={`_${1}`} loading={loadingMutation} onClick={submitHandler} />,
      ]}
    >
      <ContactForm form={form} meetingMode={meetingMode} />
    </Modal>
  );
};

export default AddFinanceContact;
